import { statusColor } from "../../utils/helpers";
import ToggleSwitch from "./ToggleSwitch";

export default function BotCard({ bot, onToggle }) {
  return (
    <article className="glass tap rounded-app p-4">
      <div className="flex items-start justify-between gap-3">
        <div><h3 className="font-bold">@{bot.bot_username}</h3><p className="text-sm text-tg-hint">{bot.template_name}</p></div>
        <span className={`mt-1 h-3 w-3 rounded-full ${statusColor(bot.status)}`} />
      </div>
      <div className="mt-4 grid grid-cols-3 gap-2 text-center text-xs text-tg-hint">
        <span>{bot.stats?.total_users || 0}<br />Users</span><span>{bot.stats?.uptime_hours || 0}<br />Hours</span><span>{bot.stats?.messages_today || 0}<br />Msgs</span>
      </div>
      <div className="mt-4 flex items-center justify-between"><span className="text-sm">{bot.status}</span><ToggleSwitch checked={bot.status === "active"} onChange={() => onToggle?.(bot)} /></div>
    </article>
  );
}
